module.exports = __webpack_public_path__ + "static/media/PACOCA.29795a5a.svg";